import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { PasswordUpdateContent } from "./password-update.content";
import { usePasswordUpdate } from "./use-password-update";
import { defaultValues, schema, type FormInputs } from "../shared/password-form/form-validation/user-password.schema";

interface Props {
  userId: string;
  token: string;
  email: string;
}

export const PasswordUpdateContainer = ({ userId, token, email }: Props) => {
  const form = useForm<FormInputs>({ resolver: yupResolver(schema), defaultValues });
  const { update } = usePasswordUpdate(form, userId, token);

  return <PasswordUpdateContent form={form} onSubmit={form.handleSubmit(update)} email={email} />;
};
